import { PendingReferralsModel } from "one-card-pending-referrals";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let preferrals: PendingReferralsModel = {};
    let tabdata: any = [];
    let erroredOut: boolean = false;
    preferrals["erroredOut"] = erroredOut;
    let result: any = {
        referrals: preferrals,
        error: undefined
    };
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
        preferrals["erroredOut"] = true;
    }
    else if (response?.length > 0 && response[0]?.referralauths?.length > 0) {
        response[0].referralauths.forEach((ele: any) => {
            let info = {
                specialty: ele.specialty,
                referralauthunits: ele.referralauthunits,
                referredtoproviderid: ele.referredtoproviderid,
                referringproviderid: ele.referringproviderid,
                referralauthid: ele.referralauthid,
                expired: ele.expired.toString(),
                note: ele.note,
                noreferralrequired: ele.noreferralrequired,
                appointmentids: ele.appointmentids
            }
            tabdata.push(info);
        });
        preferrals['activeCount'] = response[0].referralauths.filter((item: any) => item?.expired === false).length;
        preferrals['expiredCount'] = response[0].referralauths.filter((item: any) => item?.expired === true).length;
        
        preferrals["referalsdata"] = tabdata;
    }

    result.referrals = preferrals;
    return result;
}